import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { AppTokenService } from "../app-token.service";
import { HttpHandlerService } from "../http-handler.service";
import { Observable } from "rxjs";

@Injectable()

export class RateUploadService {
    _httpHandler: HttpHandlerService;
    _apiUrl = environment.apiUrl;
    _getResourceEndPoint = 'rates';

    constructor(private httpHandler: HttpHandlerService, private appTokenService: AppTokenService) {
        this._httpHandler = httpHandler;
    }
    
    public GetAllRateTypes(params?: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/types`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetAllRatePeriods(params?: any): Observable<any> {
        let full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/periods`
        if (params?.refresh) {
            full_api_url = full_api_url + `?refresh=${new Date().getTime()}`;
        }

        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public CheckRatePeriod(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/check`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetRatePeriodByTypeId(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public AddRatePeriod(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UploadRate(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/upload`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public UpdateRatePeriodById(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public DeleteRatePeriodById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/period/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public GetRateInfoByPeriod(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/info/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    // public AddRateInfo(userData: any): Observable<any> {
    //     const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/info`;
    //     const request_options = this._httpHandler.prepareRequest(
    //         'POST',
    //         full_api_url,
    //         userData
    //     );

    //     return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    // }

    public UpdateRateInfoById(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/info`;
        const request_options = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            userData
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public DeleteRateInfoById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/info/${id}`;
        const request_option = this._httpHandler.prepareRequest('DELETE', full_api_url, {});
        return this._httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    // rate comapre 
    public getRateCompare(userData: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/compare`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            userData
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public getCustomerTaxes(req: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/customer/tax`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            req
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public UpdateRates(req: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/update/awb`
        const request_option = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            req
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public awbExistsInRatePeriod(requestObj: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/awb/check`;
        const request_options = this._httpHandler.prepareRequest(
            'POST',
            full_api_url,
            requestObj
        );

        return this._httpHandler.request(request_options, this.appTokenService.tokenizedResponse)
    }

    public getCountById(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/count/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'GET',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

    public updateCount(id: any): Observable<any> {
        const full_api_url = `${this._apiUrl}${this._getResourceEndPoint}/count/${id}`
        const request_option = this._httpHandler.prepareRequest(
            'PUT',
            full_api_url,
            {}
        );
        return this.httpHandler.request(request_option, this.appTokenService.tokenizedResponse)
    }

}